
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M19.875 3.25h-4.688l-.367-.73a.937.937 0 00-.84-.52H9.516a.927.927 0 00-.836.52l-.367.73H3.625A.625.625 0 003 3.875v1.25a.625.625 0 00.625.625h16.25a.625.625 0 00.625-.625v-1.25a.625.625 0 00-.625-.625zM5.078 20.242A1.875 1.875 0 006.95 22h9.602a1.875 1.875 0 001.87-1.758L19.25 7h-15l.828 13.242z","fill":"#282E3E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3 2)","d":"M0 0h17.5v20H0z"}})])])])
          )
        }
      }
    